import { Injectable } from "@angular/core";
import { Resposta } from "../models/resposta";
import { RespostaListaDinamica } from "../models/resposta.lista-dinamica.model";
import { Observable } from "rxjs";
import { ServiceUtil } from "../util/service.util";
import { HttpService } from "ems-oauth2-client";
import { map, catchError, publishReplay, refCount } from 'rxjs/operators';


@Injectable()
export class RespostaQuestionarioService extends ServiceUtil {
  private url = "/questionario/resposta";
  filtro: Resposta = new Resposta();
  // construtor
  constructor(private http: HttpService) {
    super();
  }

  // filtra
  filtrar(filtro: Resposta): Observable<RespostaListaDinamica> {
    let novaUrl = this.url;

    if (filtro.questionario) {
      novaUrl += "?id=" + filtro.questionario;
    }
    if (filtro.usuario) {
      novaUrl += "&usuario=" + filtro.usuario;
    }
    if (filtro.dataCriacao) {
      novaUrl += "&dtCriacao=" + filtro.dataCriacao;
    }

    if (filtro.listaRespostaItem && filtro.listaRespostaItem.length > 0) {
      let colocaVirgula = false;
      novaUrl += "&filter=";
      filtro.listaRespostaItem.forEach(item => {
        if (item.descricao) {
          if (colocaVirgula) {
            novaUrl += ", ";
          }
          novaUrl +=
            '{"pergunta":' +
            item.pergunta +
            ',"valor":' +
            '"' +
            item.descricao +
            '"}';
          colocaVirgula = true;
        } else if (item.opcaoValor) {
          if (colocaVirgula) {
            novaUrl += ", ";
          }
          novaUrl +=
            '{"pergunta":' +
            item.pergunta +
            ',"opcao":' +
            '"' +
            item.opcaoValor +
            '"}';
          colocaVirgula = true;
        } else if (item.numero) {
          if (colocaVirgula) {
            novaUrl += ", ";
          }
          novaUrl +=
            '{"pergunta":' +
            item.pergunta +
            ',"numero":' +
            '"' +
            item.numero +
            '"}';
          colocaVirgula = true;
        } else if (item.data) {
          if (colocaVirgula) {
            novaUrl += ", ";
          }
          novaUrl +=
            '{"pergunta":' +
            item.pergunta +
            ',"data":' +
            '"' +
            item.data +
            '"}';
          colocaVirgula = true;
        }
      });
    }

    return this.http
      .get(novaUrl)
      .pipe(map(this.extractObjectData),
       catchError(this.handleError),
       publishReplay(1),
       refCount());
  }

  filtrarPorListaResposta(
    listaRespostas: Resposta[],
    idQuestionario: number
  ): Observable<RespostaListaDinamica> {
    let novaUrl = this.url + "/lista_respostas";
    novaUrl += "?id=" + idQuestionario;

    if (listaRespostas && listaRespostas.length > 0) {
      let colocaVirgula = false;
      novaUrl += "&filter=";
      listaRespostas.forEach(item => {
        if (colocaVirgula) {
          novaUrl += ",";
        }
        novaUrl += '{"id":' + item.id + "}";
        colocaVirgula = true;
      });
    }

    return this.http
      .get(novaUrl)
      .pipe(map(this.extractObjectData),
       catchError(this.handleError),
       publishReplay(1),
       refCount());
  }

  // deleta
  deletar(idResposta: number): Observable<Resposta> {
    return this.http
      .delete(this.url + "/" + idResposta)
      .pipe(map(response => response),
       catchError(this.handleError),
       publishReplay(1),
       refCount());
  }

  getRespostaPorId(id: number): Observable<Resposta> {
    return this.http
      .get(this.url + "/" + id)
      .pipe(map(this.extractObjectData),
       catchError(this.handleError),
       publishReplay(1),
       refCount());
  }

  getRespostaPorIdCompleta(id: number): Observable<Resposta> {
    return this.http
      .get(this.url + "/completo/" + id)
      .pipe(map(this.extractObjectData),
       catchError(this.handleError),
       publishReplay(1),
       refCount());
  }

  getRespostaCompletaPorPergunta(id: number): Observable<Resposta> {
    return this.http
      .get(this.url + "/completo/" + id)
      .pipe(map(this.extractObjectData),
       catchError(this.handleError),
       publishReplay(1),
       refCount());
  }

  /**
   * Recupera lista de  resposta com os respostasitens preenchidos tendo como parametro o idQuestionario
   * @param idQuestionario 
   */
  getRespostaCompletaPorQuestionario(idQuestionario: number): Observable<Resposta[]> {
    return this.http
      .get(this.url + "/completo/questionario/" + idQuestionario)
      .pipe(map(this.extractObjectData),
       catchError(this.handleError),
       publishReplay(1),
       refCount());
  }

  /**
   * Recupera a resposta completa (com pergunta e opções preechidas. )
   * @param idResposta R
   */
  getRespostaCompletaPorIdResposta(id: number): Observable<Resposta[]> {
    return this.http
      .get(this.url + "/completo/questionario/" + id)
      .pipe(map(this.extractObjectData),
       catchError(this.handleError),
       publishReplay(1),
       refCount());
  }


  /**
   * Retorna a lista de respostas mostrando somente os campos onde pergunta.filtro == true
   * @param id 
   */
  getRespostaCompletaPorQuestionarioFiltro(id: number): Observable<Resposta[]> {
    return this.http
      .get(this.url + "/completo/questionario_filtro/" + id)
      .pipe(map(this.extractObjectData),
       catchError(this.handleError),
       publishReplay(1),
       refCount());
  }
 /**
 * Retorna a resposta inicial de um questionario
 * @param idQuestionario 
 * @param parametroInicializado 
 */
  getRespostaInicial(idQuestionario: number, parametroInicializado: string): Observable<Resposta> {
    let novaUrl = this.url + "/inicial/" + idQuestionario;
    if (parametroInicializado) {
      novaUrl += "?parametro=" + parametroInicializado;
    }

    return this.http
      .get(novaUrl)
      .pipe(map(this.extractObjectData),
       catchError(this.handleError),
       publishReplay(1),
       refCount());
  }

  getRespostaPorNomeUnico(idResposta: number, nomePergunta: string): Observable<String> {
    let novaUrl = this.url + "/nome_unico";
    novaUrl += "?id=" + idResposta;
    novaUrl += "&nomePergunta=" + nomePergunta;

    return this.http
      .get(novaUrl)
      .pipe(map(this.extractObjectDataString),
       catchError(this.handleError),
       publishReplay(1),
       refCount());
  }

  /**
   * Recupera o valor de um resposta item por idRespostaItem
   * @param idRespostaItem 
   */
  getValorRespostaItem(idRespostaItem: number){
    let novaUrl = this.url + "/item/" + idRespostaItem + "/valor";
    return this.http
    .get(novaUrl)
    .pipe(map(response => {
       return response;
    }),
     catchError(this.handleError),
     publishReplay(1),
     refCount());
  }

  // extrai lista da resposta http
  private extractListData(res: any) {
    return res ;
  }

  // extrai objeto da resposta http
  private extractObjectData(res: any) {
    return res;
  }
  // extrai objeto da resposta http
  private extractObjectDataString(res: any) {
    return res;
  }
}
